<app-custom-dialog-modal
  [hideHeader]="true"
  [actionButtons]="actionButtons()"
  (actionClicked)="handleAction($event)"
>
  <div class="privacy-text">
    I hereby agree to the processing of my data in accordance with the
    <br />
    <a class="privacy-link" (click)="openPrivacyPolicyDetails($event)">privacy policy</a>
    and
    <a class="privacy-link" (click)="openCookiePolicyDetails($event)">
      technically necessary cookies
    </a>
  </div>
</app-custom-dialog-modal>
